<template>
  <SectionContainer>
    <AppHead />
    <FormContainer
      class="form-container--start"
      level="start"
      :title="sectionTitle"
      :hide-button="true"
    >
      <div class="my-3">
        <p>
          L’autodiagnostic est divisé en trois chapitres concernant
          respectivement les milieux <strong>habité</strong>,
          <strong>agricole</strong> et <strong>forestier</strong>. L’exercice
          proposé se présente sous la forme d’un questionnaire. Des points sont
          attribués en fonction des réponses données. Des espaces ont été
          insérés après chaque question dans le but d’alimenter la réflexion sur
          les réponses données.
        </p>
        <p>
          Un bilan des résultats obtenus est présenté à la fin de chacun des
          chapitres; il permet de dresser un portrait de l’état de la gestion
          des eaux pluviales sur votre territoire.
        </p>
        <p>
          Vous pouvez à tout moment accéder au bilan des résultats en cliquant
          sur le bouton « Sommaire et résultats ». La page Sommaire et résultats
          vous offre également la possibilité de naviguer entre les chapitres,
          les sections et les thèmes en cliquant simplement sur l’entête.
        </p>
        <p class="text-center fs-5">
          Pour quels milieux souhaitez-vous commencer l’autodiagnostic?
        </p>
        <div class="d-flex flex-wrap justify-content-evenly">
          <ChapterSelector
            v-for="(chapter, key) in chapters"
            :key="key"
            :chapter="chapter"
            :is-selected="isSelected(chapter.id)"
            @click="select(chapter.id)"
          />
        </div>
      </div>
      <template slot="buttons">
        <div
          ref="buttons"
          class="custom-buttons d-flex w-100 justify-content-center"
        >
          <button
            class="btn btn-primary"
            :disabled="form.processing || selectedChapters.length === 0"
            type="button"
            @click="goToChapter"
          >
            Continuer
          </button>
        </div>
      </template>
    </FormContainer>

    <div
      class="my-5 alert text-white w-75 mx-auto"
      style="background-color: var(--gdep_color__secondary-dark)"
      role="alert"
    >
      <p class="my-1">
        Pour obtenir des pistes de solution et des informations supplémentaires
        sur les éléments soulevés, il est suggéré de se référer au
        <a
          :href="downloadPdfLink"
          target="_blank"
          class="text-secondary text-500"
        >
          Guide d’accompagnement à l’Autodiagnostic municipal en gestion durable
          des eaux pluviales </a
        >. En plus de fournir des explicatifs associés à chaque question, ce
        document cherche à orienter le répondant dans les actions à entreprendre
        en lui suggérant des libellés règlementaires types, des exemples de
        règlements actuellement en vigueur au Québec et une sélection des
        meilleures pratiques à l’échelle nationale ou internationale.
      </p>
    </div>
  </SectionContainer>
</template>

<script>
import ChapterSelector from '../Components/ChapterSelector.vue'
import FormContainer from '../Components/SurveyForm/FormContainer.vue'
import App from '../Layouts/App'
export default {
  components: { FormContainer, ChapterSelector },
  layout: App,
  props: {
    chapters: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      downloadPdfLink: this.$page.props.guidePdfLink,
      sectionTitle: 'Commencer un nouveau diagnostic',
      selectedChapters: [],
      processing: false,
    }
  },
  computed: {
    form() {
      return this.$inertia.form({
        name: 'Questionnaire du ' + this.$date().format('ll'),
        chapter_ids: this.selectedChapters,
        captchaToken: null,
      })
    },
    storeSurveyRoute() {
      if (this.$page.props.auth.user && !this.$page.props.is_guest) {
        return this.$route('survey.user.store')
      }
      return this.$route('survey.guest.store')
    },
  },
  mounted() {
    window.scrollTo({
      top: document.querySelector('main').offsetTop,
    })
  },
  methods: {
    select(chapterId) {
      if (!this.isSelected(chapterId)) {
        return this.selectedChapters.push(chapterId)
      }
      return this.removeChapter(chapterId)
    },
    removeChapter(chapterId) {
      const index = this.selectedChapters.indexOf(chapterId)
      if (index > -1) {
        this.selectedChapters.splice(index, 1)
      }
    },
    isSelected(chapterId) {
      return this.selectedChapters.some((x) => x === chapterId)
    },

    goToChapter() {
      if (!this.selectedChapters) {
        return
      }
      this.createNewSurvey()
    },
    async createNewSurvey() {
      this.$toasted.show('Génération du sondage en cours...', {})
      this.form.captchaToken = await this.getCaptchaToken()

      this.form.post(this.storeSurveyRoute, {
        onSuccess: () => {
          this.$toasted.show('Nouveau sondage créé', {
            type: 'success',
            duration: 400,
          })
        },
        onError: (error) => {
          console.error(error)
          this.$toasted.global.savingError()
        },
      })
    },
    async getCaptchaToken() {
      await this.$recaptchaLoaded()
      return await this.$recaptcha('startSurvey')
    },
  },
}
</script>
<style lang="scss">
.form-container--start {
  .card-top-tab {
    text-align: center;
  }
  p {
    font-weight: 400;
    strong {
      font-weight: 600;
    }
  }
}
</style>
